<template>
  <div></div>
</template>

<script setup lang="ts">
const router = useRouter()

// 重定向到首页
onMounted(() => {
  router.push('/home')
})
</script>
